export default __webpack_public_path__ + "static/media/cancel.527bc1f4.svg";